import { render, staticRenderFns } from "./ProfileIndex.vue?vue&type=template&id=6b85dad6&scoped=true&"
import script from "./ProfileIndex.vue?vue&type=script&lang=js&"
export * from "./ProfileIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProfileIndex.vue?vue&type=style&index=0&id=6b85dad6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b85dad6",
  null
  
)

export default component.exports